import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Justify } from "react-bootstrap-icons";
import "./Lunch_Break.css";
import { useNavigate } from "react-router-dom";
import { post_add_user_logs_status_api } from "../../api";

const Lunch_Break = () => {
    const navigate = useNavigate();

    const Lunch_Break_Before_Take_Img = "https://attc.aqato.com.au/public/Logos/lunch_imgs/lunch_confirmation.png";
    const Lunch_Break_After_Take_Img = "https://attc.aqato.com.au/public/Logos/lunch_imgs/21724938_6509116.jpg";

    const [pageBanner, setPageBanner] = useState(Lunch_Break_Before_Take_Img);
    const [isLunchBreakStarted, setIsLunchBreakStarted] = useState(false);

    const moveToPreviousPage = () => {
        navigate(-1);
    }

    const showStartLunchBreakScreen = () => {
        setPageBanner(Lunch_Break_After_Take_Img);
        setIsLunchBreakStarted(true);



    }

    const pre_post_add_user_logs_status_api = async (user_status) => {
        const formData = new FormData();

        formData.append("user_status", user_status);

        try {

            const response = await post_add_user_logs_status_api(
                formData
            );

            console.log("response?.data?.response?.response", response?.data?.response?.response);

            if (
                response &&
                response?.data &&
                response?.data?.response &&
                response?.data?.response?.response === true
            ) {

                console.log("dsfdsf");
                navigate("/admin/lunch_break_started");

            } else {

                console.error(
                    "Error in deleting",
                    response?.data?.error_msg || "Unknown error"
                );

            }
        } catch (error) {

            console.error("Error in deleting", error);
        }


    }


    const startLunchBreak = () => {
        showStartLunchBreakScreen();
        // Set Local to lunch
        localStorage.setItem("user_status", "lunch");
        // end
        const userId = localStorage.getItem('AQATO_SuperAdminID');
        const channel = new BroadcastChannel('user-status-channel');
        channel.postMessage({ type: 'lunch', userId });
        pre_post_add_user_logs_status_api('lunch');

    }

    const stopLunchBreak = () => {
        setPageBanner(Lunch_Break_Before_Take_Img);
        setIsLunchBreakStarted(false);
        localStorage.removeItem("user_status");

        const userId = localStorage.getItem('AQATO_SuperAdminID');
        const channel = new BroadcastChannel('user-status-channel');
        channel.postMessage({ type: 'go_back_original_url', userId });
        navigate("/admin/lunch_break");
        pre_post_add_user_logs_status_api('online');


    }

    useEffect(() => {
        const checkLunchBreakGoing = localStorage.getItem("user_status");

        // if(checkLunchBreakGoing === "lunch"){
        //     setIsLunchBreakStarted(true);
        //     showStartLunchBreakScreen();
        // }
    }, []);

    return (
        <>
            <div className="main_desktop">
                <hr className="mb-2 thick-hr" />

                <div className="main-heading-title container">

                    <div className="main_wrapper_lunch mt-5">
                        <div className="image_lunch_wrapper">
                            <img src={pageBanner} />
                        </div>
                        <div className="text-warpper-lunch mt-3">
                            {(!isLunchBreakStarted) && (
                                <h5 className="heading-admin-title text-color-green">
                                    Are you sure you want to take Break?
                                </h5>
                            )}

                            <div className="action_buttons_lunch text-center mt-3">
                                {(isLunchBreakStarted) ? (

                                    <button type="button" title="Stop Break" className="ml-1 mr-1 btn btn-danger"
                                        onClick={stopLunchBreak}
                                    >
                                        <i class="bi bi-stop-circle-fill" /> Stop Break
                                    </button>
                                ) : (
                                    <>

                                        <button type="button" title="Start Break" className="btn_green_yellow ml-1 mr-1 btn btn-primary"
                                            onClick={startLunchBreak}
                                        >
                                            <i class="bi bi-play-fill" /> Start Break
                                        </button>

                                        {/* <button type="button" title="Go Back to Homepage" className="btn_yellow_green btn btn-primary"
                                            onClick={moveToPreviousPage}
                                            style={{ outline: 'none', boxShadow: 'none', border: 'none' }}>
                                            <i class="bi bi-arrow-left-circle-fill" /> Go Back
                                        </button> */}

                                    </>
                                )}



                            </div>
                        </div>
                    </div>


                </div>


            </div>
        </>
    );
};

export default Lunch_Break;
